export default {
  ErrorPlacement__ICON_ARIA: "Picture",
  ErrorPlacement__TEXT: "That wasn't supposed to happen!",
};
